import React from 'react';
import { History } from 'history';
import Model from './event-model';  //editable..
import AppService from '../../services/app.service';
import BaseCreateEdit from '../base/base-create-edit.component';

interface IProps { 
    history: History,
    parentId: number;
    sectionId?: number;
    datarowSection?: any;
    datarow?: any;
    pageDirection?: number;
    onSave?: (data: any) => void;
    onSaveBefore?: () => void;
}

interface IState {
    datarow: Model;
    errors: any;
    sectionId: number;
    buttonCaption: string,
    pageDirection: number;
}

export default class EventCreatePublic extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            sectionId: this.props.sectionId || this.props.datarowSection.id,
            buttonCaption: ' ',
            pageDirection: this.props.pageDirection || 0,
        }
        this.onChange = this.onChange.bind(this);
    }

    private historyState: any = this.props.history.location.state;

    private pageDirection(data?: any) {
        if (this.state.pageDirection > 0) 
            this.props.history.push(Model.url, {id: data.id, eventInfo: AppService.historyState()?.eventInfo});
        else
            this.props.history.goBack();
        
        if (this.state.datarow.type.startsWith('meeting-'))
            AppService.openLink(this.state.datarow.addressLinkpath);
    }

    private onLoad = async(data: any) => {
        if (data && !data.id) {
            const fullname = AppService.strCapitalize(this.historyState?.eventInfo?.participantCaption); 
            const separator = ' ➜ ';           
            if (data.parent) data.name = data.name + separator + this.props.datarowSection.name;
            if (fullname && !data.name.startsWith(fullname)) data.name = fullname + separator + data.name;
            data.description = data.name;
            data.section = data.parent? this.props.datarowSection.id : data.section;
            data.extratime = 'no';
            data.viewstyle = this.props.datarowSection.viewstyle;
            data.startdate = AppService.dateCurrent();
            data.enddate = null;
            data.customer = null;
            data.event = [];
            data.eventquiz = [];
            data.uid = null;
            data.image = null;
            data.imageId = 0;
            data.imageUrl = '';
            data.participant = this.historyState?.eventInfo?.participant;
            data.participantCaption = this.historyState?.eventInfo?.participantCaption;
            data.parent = this.props.parentId; //put after data.section
        }
        await this.setState({datarow: data, buttonCaption: this.state.pageDirection && !data.enddate? (data.id? 'Lanjut' : 'Mulai') : ' '});
    }

    private onError = (data: any) => {
        this.setState({errors: data});
    }

    private onSave = (data: any) => {
        this.props.onSave?.(data);
        if (data.id) this.pageDirection(data);
    }

    private onSaveBefore = async() => {
        await this.props.onSaveBefore?.();
        await this.setState({datarow: { ...this.state.datarow, ...this.props.datarow}});
    }

    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..

            <BaseCreateEdit id={0} copyId={this.props.parentId} caption=' ' buttonCaption={this.state.buttonCaption} successCaption=' '
                model={Model} endPointFilter={Model.endPointFilter2(this.props.parentId, this.state.sectionId)} datarow={this.state.datarow} onSaveBefore={this.onSaveBefore} onSave={this.onSave} onLoad={this.onLoad} onError={this.onError} disableAutoBack disableBackButton disableCard/>
        );
    }
}